import React from 'react';
export var DayIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
    React.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
    React.createElement("path", { d: "M13.5 5.5v-3h-3L8 0 5.5 2.5h-3v3L0 8l2.5 2.5v3h3L8 16l2.5-2.5h3v-3L16 8l-2.5-2.5zM8 12a4 4 0 110-8 4 4 0 010 8z", fill: "#e0aa38" }))); };
//# sourceMappingURL=DayIcon.js.map